<template>
  <div>
    <Head title="Create Purchase Request" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/purchases">PR</Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.project_id" :error="form.errors.project_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Project">
            <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.title }}</option>
          </select-input>
          <select-input v-model="form.project_activity_id" :error="form.errors.project_activity_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Project Activity">
            <option v-for="projectactivity in projectactivities" :key="projectactivity.id" :value="projectactivity.id">{{ projectactivity.name }}</option>
          </select-input>
          <text-input v-model="form.pr_location" :error="form.errors.pr_location" class="pb-8 pr-6 w-full lg:w-1/2" label="PR Location" />
          <select-input v-model="form.pr_allocation" :error="form.errors.pr_allocation" class="pb-8 pr-6 w-full lg:w-1/2" label="PR Allocation">
            <option value="PRG">PROGRAM</option>
            <option value="OPR">OPERASIONAL</option>
          </select-input>
          <text-input v-model="form.pr_created_date" :error="form.errors.pr_created_date" class="pb-8 pr-6 w-full lg:w-1/2" input-class="bg-gray-200" label="PR Date (Auto)" disabled />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Description" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Purchase Request</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import { format } from 'date-fns'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextareaInput,
    TextInput,
  },
  layout: Layout,
  props: {
    projects: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        project_id: null,
        project_activity_id: null,
        pr_location: null,
        pr_allocation: 'PRG',
        pr_created_date: format(new Date(), 'dd-MMM-yyyy'),
        description: null,
      }),
      projectactivities: [],
    }
  },
  watch: {
    'form.project_id': function (newVal) {
      this.getActivityByProject(newVal)
    },
  },
  methods: {
    store() {
      this.form.post('/purchases')
    },
    getActivityByProject(projectId) {
      fetch(`/projectactivities?project=${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.projectactivities = data.data
        })
    },
  },
}
</script>
